"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("../components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = function _default(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$position = options.position,
      position = _options$position === void 0 ? "fixed" : _options$position;
  return /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
    var children = _ref.children,
        props = _objectWithoutProperties(_ref, ["children"]);

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      ref: ref
    }), children, !props.loading || position !== "absolute" ? null : /*#__PURE__*/_react["default"].createElement(LoadingComponent, options)), !props.loading || position !== "fixed" ? null : /*#__PURE__*/_react["default"].createElement(LoadingComponent, options));
  });
};

exports["default"] = _default;

var LoadingComponent = /*#__PURE__*/_react["default"].memo(function (_ref2) {
  var color = _ref2.color,
      _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? "fixed" : _ref2$position,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? "" : _ref2$className,
      _ref2$scale = _ref2.scale,
      scale = _ref2$scale === void 0 ? 1 : _ref2$scale;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n    ".concat(position, " left-0 top-0 right-0 bottom-0\n    flex justify-center items-center z-50 bg-black opacity-50\n    ").concat(className, "\n  ")
  }, /*#__PURE__*/_react["default"].createElement(_components.ScalableLoading, {
    scale: scale,
    color: color
  }));
});